import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import apiClient from './services/axios'
import ContentHeader from './components/ContentHeader.vue'
import AppContent from './components/AppContent.vue'

import FloatingVue from 'floating-vue'
import VueTheMask from 'vue-the-mask'
import 'floating-vue/dist/style.css'
import './assets/styles/main.css'

import DevicePlugin from './plugins/devicePlugin'
import VueParticles from 'vue-particles'

// PrimeVue v4 (tema por preset + componentes renomeados)
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import 'primeicons/primeicons.css'
import Select from 'primevue/select'
import DatePicker from 'primevue/datepicker'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import InputText from 'primevue/inputtext'
import InputButton from 'primevue/button'
import 'primeicons/primeicons.css'

const app = createApp(App)

app.config.globalProperties.$axios = apiClient

app.use(store)
app.use(router)
app.use(FloatingVue)
app.use(VueTheMask)
app.use(DevicePlugin)
app.use(VueParticles)
app.component('InputGroup', InputGroup)
app.component('InputGroupAddon', InputGroupAddon)
app.component('InputText', InputText)
app.component('PrimeButton', InputButton)

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: false
    }
  }
})

app.component('content-header', ContentHeader)
app.component('app-content', AppContent)
app.component('PrimeSelect', Select)
app.component('PrimeDatePicker', DatePicker)

app.mount('#app')
